/**
 * Directive v-prevent-double-click
 *
 * Previne double-click em botões que disparam operações assíncronas.
 * Ao clicar, desabilita o botão e adiciona loading por um tempo mínimo,
 * ou até que a Promise retornada pelo handler seja resolvida.
 *
 * Uso simples (desabilita por 2s):
 *   <v-btn v-prevent-double-click @click="salvar">Salvar</v-btn>
 *
 * Uso com tempo customizado:
 *   <v-btn v-prevent-double-click="3000" @click="salvar">Salvar</v-btn>
 */
const PreventDoubleClick = {
    install(Vue) {
        Vue.directive('prevent-double-click', {
            bind(el, binding) {
                const timeout = binding.value || 2000;

                el.addEventListener('click', () => {
                    // Já está desabilitado — ignora
                    if (el.classList.contains('v-btn--disabled')) return;

                    // Desabilita
                    el.classList.add('v-btn--disabled');
                    el.classList.add('v-btn--loading');
                    el.style.pointerEvents = 'none';

                    // Reabilita após timeout
                    setTimeout(() => {
                        el.classList.remove('v-btn--disabled');
                        el.classList.remove('v-btn--loading');
                        el.style.pointerEvents = '';
                    }, timeout);
                }, true); // capture phase — antes do @click do Vue
            }
        });
    }
};

export default PreventDoubleClick;



// WEBPACK FOOTER //
// ./src/plugins/preventDoubleClick.js